import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./index.css";
import SinglePageAppLink from "../../../../../SinglePageAppLink";

const Pill = ({
  friendlyName,
  linkUrl,
  isHighlighted,
  pillNumber,
  totalPills
}) => {
  const classNames = classnames(styles.pill, {
    [styles.highlightedCategory]: isHighlighted
  });

  return (
    <li>
      {isHighlighted ? (
        <span className={classNames}>{friendlyName} </span>
      ) : (
        <SinglePageAppLink
          href={linkUrl}
          className={classNames}
          pillNumber={pillNumber}
          totalPills={totalPills}
          friendlyName={friendlyName}
        >
          {friendlyName}
        </SinglePageAppLink>
      )}
    </li>
  );
};

Pill.propTypes = {
  friendlyName: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool,
  pillNumber: PropTypes.number.isRequired,
  totalPills: PropTypes.number.isRequired
};

export default Pill;
